import { Box, Button, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { focusElemnt, isEmpty, navigation3 } from '../../../../common/helper'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import { XMarkSvg } from '../../../../common/svg/xMark'
import { CheckMarkSvg } from '../../../../common/svg/checkMark'
import moment from 'moment'
import EditIcon from '@mui/icons-material/Edit'
import CreateNewPartyModal from './CreateNewPartyModal'
import TablePaginationCustom from '../../../../common/TablePagination'
import { urls } from '../../../../common/constants'
import { GetRequest, PostRequest } from '../../../../common/api'
import { alertAtom, globalLoaderAtom } from '../../../../common/jotaiState/globalStateAtoms'
import { useAtom } from 'jotai'
import useToken from '../../../../helpers/useTokens'
import { RenderTable } from '../../../Reports/analysisReport/summmaryTable'
import VirtualizedTable from '../../../../common/virtualisedTable'
import { exportToExcel } from '../../../../common/hook'
import { useTranslation } from '../../../../../i18n/I18nProvider'

const PartyConfigTable = (props) => {
  const {  goToTabs } = props
  const exportRef = useRef(null);
  const [tableData, setTableData] = useState([])
  const [tableDataForExcel, setTableDataForExcel] = useState([])
  const [filteredData, setFilteredData] = useState([])
  const [editData, setEditData] = useState({})
  const [showCreatePartyModal, setShowCreatePartyModal] = useState(false)
  const [createPartyData, setCreatePartyData] = useState({})
  const { loginData } = useToken()
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [page, setPage] = useState(0)
  const [totalNoOfRows, setTotalNoOfRows] = useState(0)
  const [, setLoader] = useAtom(globalLoaderAtom)
  const [, setAlert] = useAtom(alertAtom)
  const { translations } = useTranslation()
  const gs = translations?.generalSettings || {}
  const tr = (key, fallback) => gs?.[key] || fallback
  
  const [searchData, setSearchData] = useState({
    Party: "",
    PartyID: "",
    accountingBranchVal: "",
    PartyCitiesNames: "",
    contactPersonVal: "",
    PhoneNo: "",
    modifiedByUserVal: "",
    ModifiedDateTime: "",
    IsRCMValue: "",
    IsGSTValid: "",
    IsReceiverParty: "",
    IsCommApplicable: "",
    BookingCreditLimit: "",
    IsRateAllIncluded: "",
    TargetAmount: "",
    TargetDays: ''
  })
  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
  useEffect(() => {
    focusElemnt('createNewPartyBtn')
  }, [])

  useEffect(() => {
    getTableData()
  }, [loginData])

  const getTableData = async (page=0, rowsPerPage=10) => {
    if (!isEmpty(loginData)) {
      let object = {
        PartyID	: 0,
        CompanyID: loginData?.intCompanyID,
        // PartyName: "",
        // ContactPerson: "",
        CityID: 0,
        IsCreditParty: -1,
        IsActive: -1,
        IsDeleted: -1,
        PageNo:1,
        NoOfRows:50000
      }
      setLoader(true)
      const res =  await GetRequest(urls.getPartyMasterListAll, object)
      setLoader(false)
      if (res.status === 'Success') {
        if (res?.Data?.Table?.length > 0) {
          const data = [...res?.Data?.Table]
          let newData = data?.map((val, i) => ({
            ...val,SN:(i+1)+(page*rowsPerPage), IsRCMValue: val.IsRCM === 0 ? tr('gsNo', 'No') : tr('gsYes', 'Yes'), IsGSTValid: val.IsGSTNValidated === 0 ? tr('gsNo', 'No') : tr('gsYes', 'Yes'), PartyCitiesNames: val.PartyCitiesNames?.replaceAll('~', ', '),
            IsReceiverParty: val.IsReceivingParty === 0 ? tr('gsNo', 'No') : tr('gsYes', 'Yes'),modifiedByUserVal:`${val.ModifiedByUser}\n${val?.ModifiedDateTime === '' || val?.ModifiedDateTime === null || val?.ModifiedDateTime === undefined ? '' : moment(val?.ModifiedDateTime).format('DD-MMM-YYYY')}`,
            accountingBranchVal:`${val?.AccountingBranch ?? ''}\n${val?.PartyCitiesNames?.replaceAll('~', ', ') ?? ''}`,contactPersonVal:`${val.ContactPerson ??''}\n${val?.MobileNo ??''}`,
            IsCommApplicable:val.CommissionAmt===0 && val.CommissionPCT===0?tr('na', 'NA'):val.CommissionAmt===0 && val.CommissionPCT!==0?`${val.CommissionPCT}%`:val.CommissionAmt!==0 && val.CommissionPCT===0?`${val.CommissionAmt}`:'',
            IsRateAllIncluded: val.IsRateIncludeAll===1?tr('gsYes', 'Yes'):tr('gsNo', 'No'),dataType:'entry'
          }))
          setTableData(newData)
          setTotalNoOfRows(res?.Data?.Table1?.[0]?.totalRows)
        } else {
          setTableData([])
          setTotalNoOfRows(0)
        }
      } else{
        setAlert({ show: true, msg: res?.ErrMessage || tr('noData', 'No Data'), nextId: '' })
      }
    }
  }
  const handleExport = async () => {
    try {
      if (!isEmpty(loginData)) {
        let object = {
          PartyID: 0,
          CompanyID: loginData?.intCompanyID,
          CityID: 0,
          IsCreditParty: -1,
          IsActive: -1,
          IsDeleted: -1,
          PageNo:1,
          NoOfRows: 50000
        }
        setLoader(true)
        const res = await GetRequest(urls.getPartyMasterListAll, object)
        setLoader(false)
        if (res.status === 'Success') {
          if (res?.Data?.Table?.length > 0) {
            const data = [...res?.Data?.Table]
            let newData = data?.map((val, i) => ({
              ...val, SN:i + 1, 
              IsRCMValue: val.IsRCM === 0 ? tr('gsNo', 'No') : tr('gsYes', 'Yes'),
              IsGSTValid: val.IsGSTNValidated === 0 ? tr('gsNo', 'No') : tr('gsYes', 'Yes'),
              PartyCitiesNames: val.PartyCitiesNames?.replaceAll('~', ', '),
              IsReceiverParty: val.IsReceivingParty === 0 ? tr('gsNo', 'No') : tr('gsYes', 'Yes'), 
              ModifiedDateTime: `${val?.ModifiedDateTime === '' || val?.ModifiedDateTime === null || val?.ModifiedDateTime === undefined ? '' : moment(val?.ModifiedDateTime).format('DD-MMM-YYYY')}`,
              accountingBranchVal: `${val.PartyCitiesNames?.replaceAll('~', ', ')}`,
              IsCommApplicable: val.CommissionAmt === 0 && val.CommissionPCT === 0 ? tr('na', 'NA') : val.CommissionAmt === 0 && val.CommissionPCT !== 0 ? `${val.CommissionPCT}%` : val.CommissionAmt !== 0 && val.CommissionPCT === 0 ? `${val.CommissionAmt}` : '',
              IsRateAllIncluded: val.IsRateIncludeAll === 1 ? tr('gsYes', 'Yes') : tr('gsNo', 'No'),
              IsActive: val.IsActive === 1 ? tr('gsYes', 'Yes') : tr('gsNo', 'No')
            }))
            setTableDataForExcel(newData)
            setTimeout(() => {
              exportRef.current.handleDownload();
            }, 500); 
          } else {
            setTableDataForExcel([])
          }
        } else {
          setAlert({ show: true, msg: res?.ErrMessage || tr('noData', 'No Data'), nextId: '' })
        }
      }
    } catch (err) {
      console.error("Error fetching Party Master Data:", err);
    }
  };
  const columnDefsRaw = [
    { headerName: 'SN', translationKey: 'gsSN', field: 'SN', headerSx: { padding: '6px', textAlign: 'right', minWidth: '2.24%' }, dataType: 'string', showfilter: false, allowSorting: false },
    { headerName: 'Party Name\nParty ID', translationKey: 'partyNamePartyId', field: 'Party', headerSx: { padding: '6px', textAlign: 'left', minWidth: '10.49%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Accounting Branch\nAssigned Cities', translationKey: 'accountingBranchAssignedCities', field: 'accountingBranchVal', headerSx: { padding: '6px', textAlign: 'left', minWidth: '14.49%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Contact Person\nContact No.', translationKey: 'contactPersonContactNo', field: 'contactPersonVal', headerSx: { padding: '6px', textAlign: 'left', minWidth: '11.99%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Modified By\nMod. Time & Date', translationKey: 'modifiedByModTimeDate', field: 'modifiedByUserVal', headerSx: { padding: '6px', textAlign: 'left', minWidth: '11.99%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'RCM\nApplicable', translationKey: 'rcmApplicable', field: 'IsRCMValue', headerSx: { padding: '6px', textAlign: 'left', minWidth: '4.87%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'GSTIN\nValidated', translationKey: 'gstinValidated', field: 'IsGSTValid', headerSx: { padding: '6px', textAlign: 'left', minWidth: '4.87%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Party as\nReceiver', translationKey: 'partyAsReceiver', field: 'IsReceiverParty', headerSx: { padding: '6px', textAlign: 'left', minWidth: '4.87%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Incl.All\nRates', translationKey: 'inclAllRates', field: 'IsRateAllIncluded', headerSx: { padding: '6px 2px 6px 2px', textAlign: 'right', minWidth: '5.87%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Comm.\nApplied', translationKey: 'commApplied', field: 'IsCommApplicable', headerSx: { padding: '6px', textAlign: 'right', minWidth: '4.87%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { headerName: 'Credit\nLimit', translationKey: 'creditLimit', field: 'BookingCreditLimit', headerSx: { padding: '6px 2px 6px 2px', textAlign: 'right', minWidth: '5.87%' }, dataType: 'string', showfilter: false, allowSorting: false },
    { headerName: 'Target\nAmount', translationKey: 'targetAmountHdr', field: 'TargetAmount', headerSx: { padding: '6px 3px 6px 2px', textAlign: 'right', minWidth: '4.87%' }, dataType: 'string', showfilter: false, allowSorting: false },
    { headerName: 'Targets\nDays', translationKey: 'targetsDays', field: 'TargetDays', headerSx: { padding: '6px 2px 6px 2px', textAlign: 'right', minWidth: '4.87%' }, dataType: 'string', showfilter: false, allowSorting: false },
    { headerName: 'Active\nStatus', translationKey: 'activeStatus', field: 'IsActive', headerSx: { padding: '6px', textAlign: 'left', minWidth: '3.7%' }, dataType: 'string', showfilter: false, allowSorting: false },
    { headerName: 'Change\nStatus', translationKey: 'changeStatus', field: 'status', headerSx: { padding: '6px', textAlign: 'left', minWidth: '3.7%' }, dataType: 'string', showfilter: false, allowSorting: false },
    { headerName: 'Edit', translationKey: 'edit', field: 'edit', headerSx: { padding: '6px', textAlign: 'left', minWidth: '3.4%' }, dataType: 'string', showfilter: false, allowSorting: false },
  ]
  const columnDefs = columnDefsRaw.map((c) => ({ ...c, headerName: tr(c.translationKey, c.headerName) }))
  const columnDefsForExcelRaw = [
    { header: 'SN', translationKey: 'gsSN', field: 'SN', headerSx: { padding: '6px', textAlign: 'right', minWidth: '2.24%' }, dataType: 'string', showfilter: false, allowSorting: false },
    { header: 'Party Name', translationKey: 'partyName', field: 'Party', headerSx: { padding: '6px', textAlign: 'left', minWidth: '10.49%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { header: 'Party ID', translationKey: 'partyId', field: 'PartyID', headerSx: { padding: '6px', textAlign: 'left', minWidth: '10.49%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { header: 'Accounting Branch', translationKey: 'accountingBranch', field: 'AccountingBranch', headerSx: { padding: '6px', textAlign: 'left', minWidth: '14.49%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { header: 'Assigned Cities', translationKey: 'assignedCities', field: 'PartyCitiesNames', headerSx: { padding: '6px', textAlign: 'left', minWidth: '14.49%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { header: 'Contact Person', translationKey: 'contactPerson', field: 'ContactPerson', headerSx: { padding: '6px', textAlign: 'left', minWidth: '11.99%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { header: 'Contact No.', translationKey: 'contactNo', field: 'MobileNo', headerSx: { padding: '6px', textAlign: 'left', minWidth: '11.99%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { header: 'Modified By', translationKey: 'modifiedBy', field: 'ModifiedByUser', headerSx: { padding: '6px', textAlign: 'left', minWidth: '11.99%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { header: 'Mod. Time & Date', translationKey: 'modTimeDateShort', field: 'ModifiedDateTime', headerSx: { padding: '6px', textAlign: 'left', minWidth: '11.99%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { header: 'RCM\nApplicable', translationKey: 'rcmApplicable', field: 'IsRCMValue', headerSx: { padding: '6px', textAlign: 'left', minWidth: '4.87%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { header: 'GSTIN\nValidated', translationKey: 'gstinValidated', field: 'IsGSTValid', headerSx: { padding: '6px', textAlign: 'left', minWidth: '4.87%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { header: 'Party as\nReceiver', translationKey: 'partyAsReceiver', field: 'IsReceiverParty', headerSx: { padding: '6px', textAlign: 'left', minWidth: '4.87%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { header: 'Incl.All\nRates', translationKey: 'inclAllRates', field: 'IsRateAllIncluded', headerSx: { padding: '6px 2px 6px 2px', textAlign: 'left', minWidth: '5.87%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { header: 'Comm.\nApplied', translationKey: 'commApplied', field: 'IsCommApplicable', headerSx: { padding: '6px', textAlign: 'right', minWidth: '4.87%' }, dataType: 'string', showfilter: true, allowSorting: false },
    { header: 'Credit\nLimit', translationKey: 'creditLimit', field: 'BookingCreditLimit', headerSx: { padding: '6px 2px 6px 2px', textAlign: 'right', minWidth: '5.87%' }, dataType: 'string', showfilter: false, allowSorting: false },
    { header: 'Target\nAmount', translationKey: 'targetAmountHdr', field: 'TargetAmount', headerSx: { padding: '6px 3px 6px 2px', textAlign: 'right', minWidth: '4.87%' }, dataType: 'string', showfilter: false, allowSorting: false },
    { header: 'Targets\nDays', translationKey: 'targetsDays', field: 'TargetDays', headerSx: { padding: '6px 2px 6px 2px', textAlign: 'right', minWidth: '4.87%' }, dataType: 'string', showfilter: false, allowSorting: false },
    { header: 'Active\nStatus', translationKey: 'activeStatus', field: 'IsActive', headerSx: { padding: '6px', textAlign: 'right', minWidth: '3.7%' }, dataType: 'string', showfilter: false, allowSorting: false },
    { header: 'Change\nStatus', translationKey: 'changeStatus', field: 'status', headerSx: { padding: '6px', textAlign: 'right', minWidth: '3.7%' }, dataType: 'string', showfilter: false, allowSorting: false },
    { header: 'Edit', translationKey: 'edit', field: 'edit', headerSx: { padding: '6px', textAlign: 'right', minWidth: '3.4%' }, dataType: 'string', showfilter: false, allowSorting: false },
  ]
  const columnDefsForExcel = columnDefsForExcelRaw.map((c) => ({ ...c, header: tr(c.translationKey, c.header) }))

  useEffect(() => {
    setFilteredData(tableData)
  }, [tableData])

  const showUpdateCreateNewPartyModal = () => {
    const dataValues = {
      editData: {},
      isEdit: false,
      updateModal: setShowCreatePartyModal,
      headerText: tr('createNewParty', 'Create New Party'),
      getTableData: getTableData,
      goToTabs:goToTabs
    }
    setCreatePartyData(dataValues)
    setShowCreatePartyModal(true)
  }
  const showUpdateEditPartyModal = () => {
    const dataValues = {
      isEdit: true,
      updateModal: setShowCreatePartyModal,
      headerText: tr('editParty', 'Edit Party'),
      getTableData: getTableData
    }
    setCreatePartyData(dataValues)
    setShowCreatePartyModal(true)
  }
  useEffect(() => {
    let fiterData = tableData.filter((val) =>
      (searchData?.Party === "" || (val?.Party && val?.Party?.toLocaleLowerCase().includes(searchData?.Party?.toLocaleLowerCase()))) &&
      (searchData?.Party === "" || (val?.PartyID && val?.PartyID?.toString().includes(searchData?.PartyID?.toLocaleLowerCase()))) &&
      (searchData?.accountingBranchVal === "" || (val?.accountingBranchVal && val?.accountingBranchVal?.toLocaleLowerCase().includes(searchData?.accountingBranchVal?.toLocaleLowerCase()))) &&
      // (searchData?.AccountingBranch === "" || (val?.PartyCitiesNames && val?.PartyCitiesNames?.toLocaleLowerCase().includes(searchData?.AccountingBranch?.toLocaleLowerCase()))) &&
      (searchData?.contactPersonVal === "" || (val?.contactPersonVal && val?.contactPersonVal?.toLocaleLowerCase().includes(searchData?.contactPersonVal?.toLocaleLowerCase()))) &&
      // (searchData?.ContactPerson === "" || (val?.PhoneNo && val?.PhoneNo?.toString().includes(searchData?.ContactPerson?.toLocaleLowerCase()))) &&
      (searchData?.modifiedByUserVal === "" || (val?.modifiedByUserVal && val?.modifiedByUserVal?.toLocaleLowerCase().includes(searchData?.modifiedByUserVal?.toLocaleLowerCase()))) &&
      // (searchData?.ModifiedByUser === "" || (val?.ModifiedDateTime && val?.ModifiedDateTime?.toLocaleLowerCase().includes(searchData?.ModifiedByUser?.toLocaleLowerCase()))) &&
      (searchData?.IsRCMValue === "" || (val?.IsRCMValue && val?.IsRCMValue?.toLocaleLowerCase().includes(searchData?.IsRCMValue?.toLocaleLowerCase()))) &&
      (searchData?.IsGSTValid === "" || (val?.IsGSTValid && val?.IsGSTValid?.toLocaleLowerCase().includes(searchData?.IsGSTValid?.toLocaleLowerCase()))) &&
      (searchData?.IsReceiverParty === "" || (val?.IsReceiverParty && val?.IsReceiverParty?.toLocaleLowerCase().includes(searchData?.IsReceiverParty?.toLocaleLowerCase()))) &&
      (searchData?.IsCommApplicable === "" || (val?.IsCommApplicable && val?.IsCommApplicable?.toString().toLocaleLowerCase().includes(searchData?.IsCommApplicable?.toLocaleLowerCase()))) &&
      (searchData?.BookingCreditLimit === "" || (val?.BookingCreditLimit && val?.BookingCreditLimit.toString().includes(searchData?.BookingCreditLimit))) &&
      (searchData?.IsRateAllIncluded === "" || (val?.IsRateAllIncluded && val?.IsRateAllIncluded?.toLocaleLowerCase().includes(searchData?.IsRateAllIncluded?.toLocaleLowerCase()))) &&
      (searchData?.TargetAmount === "" || (val?.TargetAmount && val?.TargetAmount.toString().includes(searchData?.TargetAmount))) &&
      (searchData?.TargetDays === "" || (val?.TargetDays && val?.TargetDays.toString().includes(searchData?.TargetDays)))
    );
    setFilteredData(fiterData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchData]);
  const handleSearchData = (event, field) => {
    let value = event.target.value.toString(); // Convert value to string
    setSearchData({ ...searchData, [field]: value });
  }
  const saveApi = async (row) => {
    let body = {
      PartyID: row?.PartyID || 0,
      CompanyID: row?.CompanyID || loginData?.intCompanyID,
      Party: row?.Party,
      ContactPerson: row?.ContactPerson,
      CityIDs: row?.CityID,
      Address: row?.Address,
      Phone: row?.PhoneNo,
      MobileNo: row?.MobileNo,
      EmailID: row?.EmailID,
      CSTNO: row?.CSTNO,
      STNO: row?.STNO,
      PAN: row?.PAN,
      IsCreditParty: row?.IsCreditParty,
      dblCreditLimit: row?.CreditLimit,
      dblCreditBalance: row?.CreditBalance,
      dblDiscountPercentage: row?.DiscountPercentage,
      Remarks: row?.Remarks,
      IsActive: row?.IsActive?0:1,
      CommPct: row?.CommissionPCT,
      CommAmt: row?.CommissionAmt,
      ServiseTaxPayer: row?.ServiceTaxPayer,
      IsDeleted: row?.IsDeleted,
      MappedToBranch: row?.MappedToBranch || 0,
      GSTN: row?.GSTN?.trim(),
      LoggedInUserID: loginData?.intUserID,
      dblBookingCreditLimit: row?.BookingCreditLimit,
      IsBookingCreditParty: row?.IsBookingCreditLimit,
      IsDelCreditParty: row?.IsDeliveryCreditLimit ? 1 : 0,
      AccountingBranchID: row?.AccountingBranchID,
      IsRateIncludeAll: row?.IsRateIncludeAll,
      IsReceivingParty: row?.IsReceivingParty,
      IsCorporateParty: row?.IsCorporateParty,
      IsRCM: row?.IsRCM,
      gstinEntityName: row?.gstinEntityName,
      gstinState: row?.gstinState,
      gstinAddress: row?.gstinAddress,
      TradeName: row?.TradeName,
      Discount: row?.Discount,
      TargetAmount: row?.TargetAmount,
      TargetStartDate: row?.TargetStartDate === '' ? '' : moment(row?.TargetStartDate).format('YYYY-MM-DD'),
      TargetEndDate: row?.TargetStartDate === '' ? '' : moment(row?.TargetEndDate).format('YYYY-MM-DD'),
      ModifiedByUserID: loginData?.intUserID,
      isValid: row?.IsGSTNValidated || 0,
      CreatedBy: loginData?.strUserName,
      AuthorizedBy: row?.AuthorizedBy
    }
    setLoader(true)
    const res = await PostRequest(urls.getPartyMasterInsertUpdate, body)
    setLoader(false)
    if (res.status === 'Success') {
      getTableData()
    } else {
      setAlert({ show: true, msg: res?.Message })
    }
  }
  const textClip = (text, tooltip, extra = {}) => (
    <Tooltip title={tooltip || text}>
      <span
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "block",
          cursor: "pointer",
          ...extra
        }}
      >
        {text}
      </span>
    </Tooltip>
  );
  const PartyConfigRowVirtuoso = ({ item, index }) => {
    const base = {
      fontSize: "12px",
      color: "#444",
      padding: "4px 8px"
    };

    return (
      <>
        <TableCell style={{ ...base, width: "2.24%", textAlign: "right" }}>
          {item?.SN}
        </TableCell>

        <TableCell style={{ ...base, width: "10.49%", maxWidth: "120px" }}>
          {textClip(item.Party, item.Party, {
            textDecoration: item?.Party?.length >= 14 ? "underline" : ""
          })}
          <Typography>{item?.PartyID}</Typography>
        </TableCell>

        <TableCell style={{ ...base, width: "16.49%", maxWidth: "160px" }}>
          {textClip(item.accountingBranchVal)}
        </TableCell>

        <TableCell style={{ ...base, width: "11.99%" }}>
          {textClip(item.contactPersonVal, `${item.ContactPerson}, ${item.PhoneNo}`)}
        </TableCell>

        <TableCell style={{ ...base, width: "11.99%" }}>
          {textClip(item.modifiedByUserVal)}
        </TableCell>

        <TableCell style={{ ...base, width: "4.87%" }}>{item.IsRCMValue}</TableCell>
        <TableCell style={{ ...base, width: "4.87%" }}>{item.IsGSTValid}</TableCell>
        <TableCell style={{ ...base, width: "4.87%" }}>{item.IsReceiverParty}</TableCell>

        <TableCell style={{ ...base, width: "4.87%", textAlign: "right" }}>
          {item.IsRateAllIncluded}
        </TableCell>

        <TableCell style={{ ...base, width: "4.87%", textAlign: "right" }}>
          {item.IsCommApplicable}
        </TableCell>

        <TableCell style={{ ...base, width: "4.87%", textAlign: "right" }}>
          {item.BookingCreditLimit}
        </TableCell>

        <TableCell style={{ ...base, width: "4.87%", textAlign: "right" }}>
          {item.TargetAmount}
        </TableCell>

        <TableCell style={{ ...base, width: "4.87%", textAlign: "right" }}>
          {item.TargetDays}
        </TableCell>

        <TableCell style={{ ...base, width: "3.7%", textAlign: "center" }}>
          {item.IsActive === 1 ? <CheckMarkSvg /> : <XMarkSvg />}
        </TableCell>

        <TableCell style={{ ...base, width: "3.7%" }}>
          <span
            style={{
              display: "flex",
              justifyContent: "center",
              textDecoration: "underline",
              cursor: "pointer",
              color: "#007bfd"
            }}
            onClick={() => saveApi(item)}
          >
            {tr('change', 'Change')}
          </span>
        </TableCell>

        <TableCell style={{ ...base, width: "3.4%" }}>
          <span
            style={{
              display: "flex",
              alignItems: "center",
              color: "#007bfd",
              cursor: "pointer",
              fontWeight: "bold"
            }}
            onClick={() => {
              setEditData(item);
              showUpdateEditPartyModal();
            }}
          >
            <EditIcon sx={{ marginRight: "3px" }} />
            {tr('edit', 'Edit')}
          </span>
        </TableCell>
      </>
    );
  };
  const headerContent = () => {
    return (
      <>
        <TableRow key="foc-tbl-header" style={{ background: '#d9edff' }}>
          {columnDefs.map((col, index) => (
            <TableCell
              key={`TH-${index}`}
              style={{
                ...col.headerSx,
                verticalAlign: 'top',
                backgroundColor: '#DAEDFE',
                minHeight: '40px',
                fontFamily: 'Roboto',
                fontSize: '12px',
                fontWeight: '600',
                color: '#444444',
                textAlign: col.headerSx.textAlign
              }}
            >
              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                {col.headerName.split('\n').map((line, lineIndex) => (
                  <span key={`line-${lineIndex}`} style={{}}>
                    {line}
                  </span>
                ))}
              </div>
            </TableCell>
          ))}
        </TableRow>
        <TableRow>
          {columnDefs.map((col, index) =>
            col.showfilter ? (
              <TableCell key={`FTH-${index}`} style={{ padding: '6px 6px' }}>
                <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                  <input
                    id={`index-${index}`}
                    className="field"
                    name="cancelSearchInput"
                    style={{ width: '100%', height: '24px' }}
                    placeholder={tr('gsContains', 'Contains')}
                    onChange={(e) => handleSearchData(e, col.field)}
                  />
                  <FilterAltIcon style={{ color: '#aaa' }} />
                </div>
              </TableCell>
            ) : (
              <TableCell key={`empty-cell-${index}`}></TableCell>
            )
          )}
        </TableRow>
      </>
    )
  }
  const bodyContent = (index, row) => {
    return <PartyConfigRowVirtuoso item={row} index={index} />;
  };
  const updatedTableData= tableData.map((item)=>({...item,IsActive: item.IsActive === 1 ? tr('gsActive', 'Active') : tr('inActive', 'InActive')}))
  return (
    <>
      <Stack style={{ padding: '5px 0px' }} className="itemButtons">
        <Box style={{ display: 'flex', gap: '10px' }}>
          <Button
            variant="outlined"
            id={'createNewPartyBtn'}
            sx={{ width: '200px' }}
            className="receiveitembtn"
            onKeyDown={(e) =>
              navigation3(e, `editBtn-0`, `editBtn-${filteredData?.length - 1}`, () => {
                showUpdateCreateNewPartyModal()
              })
            }
            onClick={() => {
              showUpdateCreateNewPartyModal()
            }}
          >
            {tr('createNewLower', '+ create new')}
          </Button>
          <Button
            style={{border: '2px solid #fe5200',color: '#fe5200',fontSize:'14px',background:'none'}}
            id="xls-button-party-config"
            variant="contained"
            color="primary"
            onClick={(e) => {
              exportToExcel({
                fileName: `Party Config ${currentDateTime}.xlsx`,
                sheetName: 'PartyConfig',
                headersList: [columnDefsForExcel?.filter(col => col.field !== "status" && col.field !== "edit")],
                dataList: [updatedTableData],
              })
            }}
          >
            {tr('exportAsExcel', 'EXPORT AS EXCEL')}
          </Button>
        </Box>
      </Stack>
      <Stack sx={{ paddingTop: '10px', paddingBottom: '16px' }} className='vehicle-wise-table-box'>
        <VirtualizedTable
          tableData={filteredData}
          headerContent={headerContent}
          rowContent={bodyContent}
          tableStyle={{ tableLayout: 'auto', width: '100%' }}
          autoResize={true}
        />
      </Stack>
      {showCreatePartyModal && (
        <CreateNewPartyModal dataValues={createPartyData} updateModal={setShowCreatePartyModal} editData={editData} goToTabs={goToTabs} />
      )}
    </>
  )
}

export default PartyConfigTable
